<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Cliente/Proveedor</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<div id="container" class="mt-5">
						<div class="progress px-1" style="height: 3px;">
							<div class="progress-bar" role="progressbar" style="width: 0%;" aria-valuenow="0"
								aria-valuemin="0" aria-valuemax="100"></div>
						</div>
						<div class="step-container d-flex justify-content-between">
							<div class="step-circle"
								[ngClass]="currentStep == 1?'current-step':(currentStep>1?'success-step':'clean-step')"
								(click)="displayStep(1)">1</div>
							<div class="step-circle"
								[ngClass]="currentStep == 2?'current-step':(currentStep>2?'success-step':'clean-step')"
								*ngIf="newVendor.provider" (click)="displayStep(2)">2</div>
							<div class="step-circle" [ngClass]="currentStep == 3?'current-step':'clean-step'"
								(click)="displayStep(3)">{{newVendor.provider?3:2}}</div>
						</div>
						<div class="step step-1" *ngIf="currentStep == 1">
							<h5>Datos principales</h5>
							<div class="row">
								<div class="col-sm form-group">
									<label for="nit" class="form-label">NIT<span class="required">*</span></label>
									<input type="text" [(ngModel)]="newVendor.nit" (input)="writeNit()"
										placeholder="Ingresa el nit" name="nit" id="nit" class="form-control">
								</div>
								<div class="col-sm form-group">
									<label for="name" class="form-label">Razón/Denominación Social<span
											class="required">*</span></label>
									<input type="text" [(ngModel)]="newVendor.name"
										placeholder="Ingresa la razón o denominación social" name="name" id="name"
										class="form-control">
								</div>
							</div>
							<div class="row">
								<div class="col-sm form-group">
									<label for="cui" class="form-label">CUI/ID Extranjero</label>
									<input type="text" [(ngModel)]="newVendor.cui"
										placeholder="Ingresa el CUI o el ID extrajero" name="cui" id="cui"
										class="form-control">
								</div>
								<div class="col-sm form-group">
									<label for="code" class="form-label">Código</label>
									<input type="text" [(ngModel)]="newVendor.code" placeholder="Ingresa el código"
										name="code" id="code" class="form-control">
								</div>
								<div class="col-sm form-group" *ngIf="newVendor.priceList">
									<label for="priceList" class="form-label">Lista de precios</label>
									<select name="priceList" id="priceList" [(ngModel)]="newVendor.priceList"
										class="form-select">
										<option value="-1">Sin lista</option>
										<option *ngFor="let list of lists" value="{{list.id}}">{{list.name}}</option>
									</select>
								</div>
							</div>
							<div class="row" style="margin-top: 1em;">
								<div class="col-sm">
									<div class="form-check">
										<input class="form-check-input" (change)="changeClient()"
											[(ngModel)]="newVendor.client" type="checkbox" value="" id="client">
										<label class="form-check-label" [class.opacity-30]="!newVendor.client"
											for="client">
											Es cliente
										</label>
									</div>
								</div>
								<div class="col-sm">
									<div class="form-check">
										<input class="form-check-input" (change)="changeProvider()"
											[(ngModel)]="newVendor.provider" type="checkbox" value="" id="provider">
										<label class="form-check-label" [class.opacity-30]="!newVendor.provider"
											for="provider">
											Es proveedor
										</label>
									</div>
								</div>
								<div class="col-sm">
									<div class="form-check">
										<input class="form-check-input" [(ngModel)]="newVendor.provIn" type="checkbox"
											value="" id="provIn">
										<label class="form-check-label" [class.opacity-30]="!newVendor.provIn"
											for="provIn">
											P. Inventarios
										</label>
									</div>
								</div>
								<div class="col-sm">
									<div class="form-check">
										<input class="form-check-input" [(ngModel)]="newVendor.extranjero"
											type="checkbox" value="" id="extranjero">
										<label class="form-check-label" [class.opacity-30]="!newVendor.extranjero"
											for="extranjero">
											Es extranjero
										</label>
									</div>
								</div>
							</div>
							<div class="button-container">
								<button type="button" [disabled]="!newVendor.name || (!newVendor.nit && !newVendor.cui)"
									(click)="nextStage1()" class="btn btn-primary next-step">SIGUIENTE<i
										class="fa fa-arrow-right"></i></button>
							</div>
						</div>
						<div class="step step-2" *ngIf="currentStep == 2">
							<h5>Otros datos</h5>
							<div class="row">
								<div class="col-sm form-group">
									<label for="taxRegime" class="form-label">Regimen de impuestos<span
											class="required">*</span></label>
									<select name="taxRegime" id="taxRegime" [(ngModel)]="newVendor.taxRegime"
										class="form-select">
										<option *ngFor="let tax of regimes" value="{{tax.id}}">{{tax.name}}</option>
									</select>
								</div>
								<div class="col-sm form-group">
									<label for="" class="form-label">Días de Crédito</label>
									<select name="providerCreditDays" *ngIf="!custom" id="providerCreditDays"
										[(ngModel)]="newVendor.providerCreditDays" class="form-select">
										<option value="0">0</option>
										<option value="30">30</option>
										<option value="60">60</option>
										<option value="90">90</option>
									</select>
									<input type="number" *ngIf="custom" placeholder="Ingresa los días de crédito"
										[(ngModel)]="newVendor.providerCreditDays" class="form-control"
										id="providerCreditDays">
									<p class="form-text" [class.clicked]="custom" class="text-success clickeable"
										(click)="customizable()"><span> <i
												[ngClass]="custom?'fa fa-circle-check':'fa-regular fa-circle'"></i>
											Personalizado</span></p>
								</div>
							</div>
							<div class="row">
								<div class="col-sm form-group">
									<label for="category" class="form-label">Categoria</label>
									<div class="input-group">
										<!-- <input type="text" [(ngModel)]="searchCategory" list="all-categories"
											placeholder="Ingresa una categoria" id="category" name="category"
											class="form-control"> -->
										<app-input-autocomplete [allBorderRadius]="true"
											[filterElements]="inputCategory.filterElements"
											(changeStatus)="selectCategory($event.filterElement)"
											[inputs]="inputCategory" (inputMethod)="writeCategory()"
											(getTitle)="$event.filterElement.title = $event.filterElement.name"></app-input-autocomplete>
										<button class="btn btn-primary" [disabled]="!inputCategory.value || 
											(inputCategory.value && inputCategory.filterElements.length == 1 && !inputCategory.data)"
											(click)="addCategory()"><i class="fa fa-plus"></i></button>
									</div>
									<datalist id="all-categories">
										<option *ngFor="let category of allCategories" label="{{category.name}}"
											value="{{category.id}}">
										</option>
									</datalist>
								</div>
							</div>
							<div class="row" style="padding: 1em;" *ngIf="newVendor['categories']">
								<div class="container-subfamily" *ngIf="newVendor['categories'].length > 0">
									<ng-container *ngFor="let category of newVendor['categories']; let i = index">
										<span class="category-child-item">{{category.name}} <i
												class="a-hover fa fa-xmark" (click)="deleteCategory(i)"></i>
										</span>
									</ng-container>
								</div>
								<div *ngIf="newVendor['categories'].length == 0">
									<span class="text-muted"><i class="fa fa-circle-info"></i> No se tienen categorias
										agregadas</span>
								</div>
							</div>

							<div class="button-container">
								<button type="button" (click)="currentStep = 1; updateProgressBar()"
									class="btn btn-secondary prev-step"><i
										class="fa fa-arrow-left"></i>ANTERIOR</button>
								<button type="button" (click)="currentStep = 3; updateProgressBar()"
									class="btn btn-primary next-step">SIGUIENTE<i
										class="fa fa-arrow-right"></i></button>
							</div>
						</div>

						<div class="step step-3" *ngIf="currentStep == 3">
							<div class="row">
								<div class="col-sm form-group">
									<label for="address" class="form-label">Direccion</label>
									<input type="text" id="address" placeholder="Ingresa la dirección" name="address"
										[(ngModel)]="newVendor.address" class="form-control">
								</div>
								<div class="col-sm form-group">
									<label for="contactName" class="form-label">Nombre de contacto</label>
									<input type="text" id="contactName" placeholder="Ingresa nombre de contacto"
										name="contactName" [(ngModel)]="newVendor.contactName" class="form-control">
								</div>
							</div>
							<div class="row mb-3">
								<div class="col-sm form-group">
									<label for="contactMail" class="form-label">Correo</label>
									<input type="text" id="contactMail" placeholder="Ingresa correo" name="contactMail"
										[(ngModel)]="newVendor.contactMail" class="form-control">
								</div>
								<div class="col-sm form-group">
									<label for="contactPhone" class="form-label">Telefono</label>
									<input type="text" id="contactPhone" placeholder="Ingresa número de telefono"
										name="contactPhone" [(ngModel)]="newVendor.contactPhone" class="form-control">
								</div>
								<div class="col-sm form-group">
									<label for="contactCellphone" class="form-label">
										Celular
										<span
											*ngIf="isCellphoneRequired()"
											class="required">
											*
										</span>
									</label>

									<input
										type="text"
										id="contactCellphone"
										placeholder="Ingresa número de celular"
										name="contactCellphone"
										[(ngModel)]="newVendor.contactCellphone"
										class="form-control"
										[required]="isCellphoneRequired()">

								</div>
							</div>

							
							<div class="row mb-3" *ngIf="newVendor.client">
								<div class="col-12 col-sm-3 form-group">
									<div class="row">
										<div class="col-sm form-group">
											<label for="place" class="form-label">Selecciona Destino</label>
											<select name="place" [(ngModel)]="newVendor.place" id="place" class="form-select">
												<option [value]="null">Selecciona un Destino</option>
												<option *ngFor="let item of places" value="{{item.id}}">{{item.name}}</option>
											</select>
										</div>
									</div>
								</div>

								<div class="col-12 col-sm-auto form-group">
									<label for="clientCredit" class="form-label">Limite de Credito</label>
									<div class="d-flex flex-row items-center gap-1">
										<input type="number" id="clientCredit" placeholder="0" name="contactMail"
											[(ngModel)]="newVendor.clientCredit" [min]="0.00" class="form-control">
									</div>
								</div>
								<div class="col-12 col-sm-auto form-group">
									<label for="percentage" class="form-label">Porcentaje</label>
									<div class="d-flex flex-row items-center gap-1">
										<input type="number" id="percentage" placeholder="0" name="contactMail"
											[(ngModel)]="newVendor.percentage" [min]="0.00" [max]="100"
											class="form-control">
										<span><i class="fa fa-percentage"></i></span>
									</div>
								</div>
								<div class="col-12 mt-3" *ngIf="newVendor.client">

    <div class="billing-header">
        <label class="form-label mb-0">
            Datos de Facturación
        </label>

        <div class="form-check">
            <input
                class="form-check-input"
                type="checkbox"
                id="enableBillingData"
                [(ngModel)]="enableBillingData"
                name="enableBillingData"
                (change)="onBillingDataToggle()">

            <label
                class="form-check-label"
                for="enableBillingData">
                Agregar NIT y Nombre
            </label>
        </div>
    </div>

    <ng-container *ngIf="enableBillingData">

        <!-- FORMULARIO PARA AGREGAR -->
        <div class="row align-items-end mt-2">

            <div class="col-sm-4 form-group">
                <label
                    for="billingNitInput"
                    class="form-label">
                    NIT
                </label>

                <input
                    type="text"
                    id="billingNitInput"
                    name="billingNitInput"
                    class="form-control"
                    placeholder="Ingresa el NIT"
                    [(ngModel)]="billingNitInput">
            </div>

            <div class="col-sm form-group">
                <label
                    for="billingNameInput"
                    class="form-label">
                    Nombre
                </label>

                <input
                    type="text"
                    id="billingNameInput"
                    name="billingNameInput"
                    class="form-control"
                    placeholder="Ingresa el nombre"
                    [(ngModel)]="billingNameInput">
            </div>

            <div class="col-sm-auto form-group">
                <button
                    type="button"
                    class="btn btn-primary"
                    [disabled]="!billingNitInput || !billingNameInput"
                    (click)="addBillingData()">

                    <i class="fa fa-plus"></i>
                    Agregar

                </button>
            </div>

        </div>

        <!-- TABLA -->
        <div class="billing-table-container mt-3">

            <table class="table table-hover table-sm mb-0">

                <thead>
                    <tr>
                        <th>NIT</th>
                        <th>Nombre</th>
                        <th class="text-center billing-action-column">
                            Acción
                        </th>
                    </tr>
                </thead>

                <tbody>

                    <tr
                        *ngFor="
                            let billing of newVendor.billingRequest;
                            let i = index
                        ">

                        <td>
                            {{ billing.billingNit }}
                        </td>

                        <td>
                            {{ billing.billingName }}
                        </td>

                        <td class="text-center">

                            <button
                                type="button"
                                class="btn btn-sm btn-outline-danger"
                                title="Eliminar"
                                (click)="deleteBillingData(i)">

                                <i class="fa fa-trash"></i>

                            </button>

                        </td>

                    </tr>

                    <tr
                        *ngIf="
                            !newVendor.billingRequest ||
                            newVendor.billingRequest.length === 0
                        ">

                        <td
                            colspan="3"
                            class="text-center text-muted py-3">

                            <i class="fa fa-circle-info"></i>
                            No se tienen datos de facturación agregados

                        </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </ng-container>

</div>
							</div>
							<div class="button-container">
								<button type="button" (click)="previousStage3()" class="btn btn-secondary prev-step"><i
										class="fa fa-arrow-left"></i>ANTERIOR</button>
								<button class="btn btn-success" (click)="editOrSave()"
									[disabled]="!newVendor.name || loading">
									<ng-container *ngIf="!loading">
										<i class="fa fa-floppy-disk"></i>
									</ng-container>
									<ng-container *ngIf="loading">
										<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
										<span role="status"></span>
									</ng-container>{{isCreating?'GUARDAR':'GUARDAR CAMBIOS'}}
								</button>
							</div>
						</div>
					</div>

				</div>
				<div class="modal-footer">
					<p class="text-muted" style="margin-top: 1em; font-size: 0.8em; text-align: right;"><i
							class="fa fa-circle-info"></i>Completa los campos marcados con un <span
							class="required">*</span> para {{isCreating?'guardar':'guardar los cambios de'}}
						la persona</p>
				</div>
			</div>
		</div>
	</div>
</div>
<app-modal-question *ngIf="questionForModal" [question]="questionForModal" (close)="closeCreateCategory($event)"
	[title]="'Crear categoria'"></app-modal-question>